<template>
    <div></div>
</template>

<script>
import Vue from 'vue';

export default Vue.component({});
</script>
